import { mount } from "svelte";
import Dashboard from "../pages/Dashboard/Dashboard.svelte";

export const bindDashboard = () =>
  mount(Dashboard, { target: document.getElementById("dashboard-container") });
